import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_Tariff_Floor_Interface, Tariff_Floor_Interface } from 'src/app/Interface/Tariff_Floor_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PriceService } from 'src/app/Service/Price/Price.service';
import { TariffService } from 'src/app/Service/Tariff/Tariff.service';

@Component({
  selector: 'app-TariffFloor',
  templateUrl: './TariffFloor.component.html',
  styleUrls: ['./TariffFloor.component.scss']
})
export class TariffFloorComponent implements OnInit {

  Token:String=""
  txt_PriceAlph:String=""
  txt_Price:number=0
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private Tariff_Service:TariffService,
    private Alertify_Service:AlertifyService,
    private modalService: BsModalService,
    private Nav_Service:NavService,
    private Price_Service: PriceService,
  ) { }


  DataList_Tariff:Array<Tariff_Floor_Interface>=[]
  Data_Seleted_Delete:Tariff_Floor_Interface=Empty_Tariff_Floor_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,27).subscribe(
      data=>{
        this.ReadData_Tariff()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )    
  }

  ReadData_Tariff(){
    this.Procssing=true
    this.Tariff_Service.GetTarrifFloor(this.Token).subscribe(
      data=>{
        this.DataList_Tariff=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  modalRef_Tariff: any;
  openModal_Tariff(template: TemplateRef<any>) {
    this.modalRef_Tariff = this.modalService.show(template);
    this.txt_Price=0
  }

  Procssing_Import:boolean=false
  submitTarrif(){
    this.modalRef_Tariff.hide()
    this.Procssing_Import=true
    var temp:Tariff_Floor_Interface=Empty_Tariff_Floor_Interface()
    temp.price=this.txt_Price

    this.Tariff_Service.AddTariffFloor(temp,this.Token).subscribe(
      data=>{
        this.ReadData_Tariff()
        this.Alertify_Service.SuccessMessage("Information saved successfully.")
        this.Procssing_Import=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


  khadamat_Change() {
    this.Price_Service.GetPriceAlphabet(this.txt_Price+'').subscribe(
      data => {
        this.txt_PriceAlph = data['price']
      }
    )
  }

}
